import { type SupportedLocaleMap } from '@zep-us/i18n';
import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { FunctionCard, FunctionCards } from './FunctionCards';
export const BizHR = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <section className="px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="BizHR" data-sentry-source-file="BizHR.tsx">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-lg min-[751px]:items-stretch min-[751px]:gap-2xl">
        <h2 className="px-[16px] text-center text-display-sm-extrabold text-default min-[751px]:whitespace-normal min-[751px]:text-left">
          {t('biz-landing.hrFeatures.title')}
        </h2>
        <FunctionCards topElement={<Function1 />} bottomLeftElement={<Function2 />} bottomRightElement={<Function3 />} data-sentry-element="FunctionCards" data-sentry-source-file="BizHR.tsx" />
      </div>
    </section>;
};

// TODO: Replace with actual biz landing images
const FUNCTION_1_IMAGE_LINKS: SupportedLocaleMap<'ko' | 'en' | 'ja'> = {
  ko: '/assets/biz-landing/hr/kr/HR-image1-kr.webp',
  en: '/assets/biz-landing/hr/en/HR-image1-en.webp',
  ja: '/assets/biz-landing/hr/jp/HR-image1-jp.webp'
};
const Function1 = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  const {
    locale
  } = useLocale();
  return <FunctionCard.HorizontalWrapper className="bg-purple-50" data-sentry-element="unknown" data-sentry-component="Function1" data-sentry-source-file="BizHR.tsx">
      <div className="flex-1">
        <div className="flex size-full flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pr-0 min-[1025px]:p-3xl min-[1025px]:pr-0">
          <FunctionCard.Title className="text-purple-800" data-sentry-element="unknown" data-sentry-source-file="BizHR.tsx">
            {t('biz-landing.hrFeature1.title')}
          </FunctionCard.Title>
          <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="BizHR.tsx">
            {t('biz-landing.hrFeature1.content')}
          </FunctionCard.Description>
        </div>
      </div>

      <div className="flex-1 min-[751px]:h-[310px] min-[1025px]:h-[374px]">
        <img src={FUNCTION_1_IMAGE_LINKS[locale] ?? FUNCTION_1_IMAGE_LINKS.en} alt="Function 1" className="size-full min-[751px]:object-cover min-[751px]:object-left" />
      </div>
    </FunctionCard.HorizontalWrapper>;
};
const Function2 = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <FunctionCard.VerticalWrapper className="bg-purple-100" data-sentry-element="unknown" data-sentry-component="Function2" data-sentry-source-file="BizHR.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-purple-900" data-sentry-element="unknown" data-sentry-source-file="BizHR.tsx">
          {t('biz-landing.hrFeature2.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="BizHR.tsx">
          {t('biz-landing.hrFeature2.content')}
        </FunctionCard.Description>
      </div>

      <img src={'/assets/biz-landing/hr/HR-image2.webp'} alt="Function 2" />
    </FunctionCard.VerticalWrapper>;
};
const Function3 = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  return <FunctionCard.VerticalWrapper className="bg-[#F6F3FA]" data-sentry-element="unknown" data-sentry-component="Function3" data-sentry-source-file="BizHR.tsx">
      <div className="flex flex-col items-center gap-sm px-lg py-xl min-[751px]:items-stretch min-[751px]:gap-lg min-[751px]:p-2xl min-[751px]:pb-0 min-[1025px]:p-3xl min-[1025px]:pb-0">
        <FunctionCard.Title className="text-purple-900" data-sentry-element="unknown" data-sentry-source-file="BizHR.tsx">
          {t('biz-landing.hrFeature3.title')}
        </FunctionCard.Title>
        <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="BizHR.tsx">
          {t('biz-landing.hrFeature3.content')}
        </FunctionCard.Description>
      </div>

      <img src={'/assets/biz-landing/hr/HR-image3.webp'} alt="Function 3" />
    </FunctionCard.VerticalWrapper>;
};